"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationLedger',
  data: function data() {
    return {
      tab: 'account',
      loading: false,
      summary: {},
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        status: '',
        direction: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadSummary();
    this.loadCurrent();
  },
  methods: {
    money: function money(value) {
      return Number(value || 0).toFixed(2);
    },
    accountText: function accountText(value) {
      return {
        operating: '经营账户',
        prepaid_receipt: '预收款',
        prepaid_payment: '预付款',
        deposit: '保证金'
      }[value] || value;
    },
    reconText: function reconText(value) {
      return {
        draft: '草稿',
        pending_confirm: '待确认',
        disputed: '差异中',
        confirmed: '已确认',
        settled: '已结清',
        cancelled: '已取消'
      }[value] || value;
    },
    commissionText: function commissionText(value) {
      return {
        pending: '待核销',
        withdrawable: '可提现',
        paid: '已支付',
        cancelled: '已取消'
      }[value] || value;
    },
    actionText: function actionText(value) {
      return {
        submit: '提交',
        confirm: '确认',
        dispute: '差异',
        settle: '结清',
        cancel: '取消',
        verify: '核销',
        pay: '支付'
      }[value] || value;
    },
    loadSummary: function loadSummary() {
      var _this = this;
      (0, _decoration.decorationLedgerSummaryApi)().then(function (data) {
        _this.summary = data || {};
      });
    },
    loadCurrent: function loadCurrent() {
      var _this2 = this;
      this.loading = true;
      var done = function done(list, total) {
        _this2.tableData.data = list || [];
        _this2.tableData.total = total || 0;
        _this2.loading = false;
      };
      if (this.tab === 'account') {
        (0, _decoration.decorationLedgerAccountListApi)().then(function (data) {
          return done(data || [], (data || []).length);
        }).catch(function () {
          _this2.loading = false;
        });
        return;
      }
      var api = {
        flow: _decoration.decorationLedgerTransactionListApi,
        plan: _decoration.decorationLedgerReceivableListApi,
        recon: _decoration.decorationLedgerReconListApi,
        commission: _decoration.decorationLedgerCommissionListApi
      }[this.tab];
      api(this.searchForm).then(function (data) {
        return done(data.list || [], data.total || 0);
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.loadCurrent();
    },
    openPost: function openPost() {
      var _this3 = this;
      this.$prompt('入账金额', '经营账户收款').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationLedgerPostApi)({
          accountType: 'operating',
          direction: 'income',
          transactionType: 'receipt',
          amount: Number(value),
          remark: '后台入账'
        }).then(function () {
          _this3.$message.success('已入账');
          _this3.loadSummary();
          _this3.loadCurrent();
        });
      }).catch(function () {});
    },
    openRecon: function openRecon() {
      var _this4 = this;
      var end = new Date();
      var start = new Date(end.getFullYear(), end.getMonth(), 1);
      var fmt = function fmt(d) {
        return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'));
      };
      (0, _decoration.decorationLedgerReconSaveApi)({
        counterpartyType: 'customer',
        counterpartyId: 1,
        periodStart: fmt(start),
        periodEnd: fmt(end)
      }).then(function () {
        _this4.$message.success('对账单已生成');
        _this4.loadCurrent();
      });
    },
    openCommission: function openCommission() {
      var _this5 = this;
      this.$prompt('提成基数', '登记提成').then(function (_ref2) {
        var value = _ref2.value;
        (0, _decoration.decorationLedgerCommissionSaveApi)({
          commissionType: 'renovation_contract',
          sourceType: 'manual',
          baseAmount: Number(value),
          remark: '后台登记提成'
        }).then(function () {
          _this5.$message.success('提成已登记');
          _this5.loadCurrent();
        });
      }).catch(function () {});
    },
    runRecon: function runRecon(row, action) {
      var _this6 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationLedgerReconActionApi)(row.reconciliation.id, {
          action: action
        }).then(function () {
          _this6.$message.success('对账单已更新');
          _this6.loadCurrent();
        });
      }).catch(function () {});
    },
    runCommission: function runCommission(row, action) {
      var _this7 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationLedgerCommissionActionApi)(row.commission.id, {
          action: action
        }).then(function () {
          _this7.$message.success('提成已更新');
          _this7.loadSummary();
          _this7.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};